export default __webpack_public_path__ + "bcea4eda6db3b496d034a5c2c724f181.svg";